import {
  ArrowBack,
  ArrowForward,
  ArrowDown,
  ArrowUp,
  DesktopOutline,
  ArrowUndo,
  ArrowRedo,
  TextOutline,
  ImageSharp,
  ImageOutline,
  ImagesOutline,
  BarChartOutline,
  SaveOutline,
  CopyOutline,
  Add
} from '@vicons/ionicons5'

import {
  ClearOutlined,
  DeleteOutlined,
  DoubleRightOutlined,
  DoubleLeftOutlined,
  GithubOutlined,
  EyeFilled,
  EditOutlined,
  PlusOutlined,
  FullscreenOutlined,
  FullscreenExitOutlined
} from '@vicons/antd'

const icons = [
  Add,
  ArrowBack,
  ArrowForward,
  ArrowDown,
  ArrowUp,
  DesktopOutline,
  ArrowUndo,
  ArrowRedo,
  ClearOutlined,
  DeleteOutlined,
  TextOutline,
  ImageSharp,
  ImageOutline,
  ImagesOutline,
  BarChartOutline,
  SaveOutline,
  DoubleRightOutlined,
  DoubleLeftOutlined,
  GithubOutlined,
  EyeFilled,
  EditOutlined,
  PlusOutlined,
  FullscreenOutlined,
  FullscreenExitOutlined,
  CopyOutline
]

export function setupVicons(app) {
  icons.forEach((element) => {
    app.component(element.name, element)
  })
}
